exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.app-wrapper[data-v-60f35ab6]{position:relative;height:100%;width:100%\n}\n", "", {"version":3,"sources":["/root/36237/workspace/src/views/layout/Layout.vue"],"names":[],"mappings":";AA6CA,8BACE,kBACA,YACA,UAAW;CACZ","file":"Layout.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n// @import \"~@/styles/mixin.scss\";\n.app-wrapper {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60f35ab6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/Layout.vue
// module id = rkoI
// module chunks = 10